import axios from 'axios';
import {
	TimeSeriesRawDataLatest,
	TimeSeriesRawDataReadings,
	TimeSeriesRawDataTotal,
} from '../interfaces/api/timeseries';

export type TimeSeriesSteps = '5m' | '10m' | '15m' | '30m' | '1h' | '1d' | '7d' | '1M';

export type TimeSeriesValueType = 'avg' | 'sum' | 'count' | 'min' | 'max';

export interface TimeSeriesRawDataParam {
	tags: string[];
	start?: string;
	end?: string;
	step?: TimeSeriesSteps;
	type?: TimeSeriesValueType;
	latest?: boolean;
}

function queryBuilderRawData(params: TimeSeriesRawDataParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.tags && params.tags.length > 0) {
		for (const tag of params.tags) {
			queryParams.append('tags', tag);
		}
	}
	if (params.start) {
		queryParams.append('start', params.start);
	}
	if (params.end) {
		queryParams.append('end', params.end);
	}
	if (params.step) {
		queryParams.append('step', params.step);
	}
	if (params.latest) {
		queryParams.append('latest', String(params.latest));
	}
	if (params.type) {
		queryParams.append('type', params.type);
	}
	return queryParams;
}

export async function getRawDataLatest(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataLatest[]> {
	try {
		const queryParams = queryBuilderRawData(params);
		const response = await axios.get<TimeSeriesRawDataLatest[]>(
			'api/timeseries/get_raw_data_latest/',
			{
				params: queryParams,
			}
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getRawDataReadings(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataReadings[]> {
	try {
		const queryParams = queryBuilderRawData(params);
		const response = await axios.get<TimeSeriesRawDataReadings[]>(
			'api/timeseries/get_raw_data_readings/',
			{
				params: queryParams,
			}
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getRawDataTotal(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataTotal[]> {
	try {
		const queryParams = queryBuilderRawData(params);
		const response = await axios.get<TimeSeriesRawDataTotal[]>(
			'api/timeseries/get_raw_data_total/',
			{
				params: queryParams,
			}
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
